const useTags = async () => {
  const { data } = await window.axios.get<IPChat.Tag[]>(
    route('system.resources.getTags')
  )
  return data
}

export default useTags
